import type { Sequence } from "#public"

/**
 * Yields successive `size`-sized chunks from `items`.
 * Mirrors Python `pyfuncs.utils.functional.list_split(iterable, n)`.
 *
 * @param items - Input sequence to partition
 * @param size - Chunk length (must be positive)
 * @returns Generator yielding arrays of up to `size` items
 *
 * @example
 * ```ts
 * import { Partition } from "@pdfking/tfunc"
 *
 * [...Partition([1, 2, 3, 4, 5], 2)] // [[1, 2], [3, 4], [5]]
 * ```
 */
export function* Partition<T>(items: Sequence<T>, size: number): Generator<T[], void, unknown> {
  if (size <= 0) {
    throw new Error(`Partition size must be positive, got ${size}`)
  }
  let chunk: T[] = []
  for (const item of items) {
    chunk.push(item)
    if (chunk.length === size) {
      yield chunk
      chunk = []
    }
  }
  if (chunk.length > 0) yield chunk
}
